module.exports = __webpack_public_path__ + "img/email.e4742db4.svg";